<template lang='pug'>
.base(id="itemsWrapper")
  CursorCustom(:theme="theme")
  BaseView(
    :theme="theme"
    :appear="appear"
    :animation="animation"
    )
    PageHistory
    
</template>

<script>
import CursorCustom from "../../components/elements/Cursor/index";
import PageHistory from "../../components/blocks/PageHistory/index";
import BaseView from "../../views/BaseView/index";
export default {
  name: "History",
  data() {
    return {
      scrollbar: true,
      type: "full",
      theme: "dark",
      appear: "normal",
      animation: "clear"
    };
  },
  methods: {

  },
  beforeDestroy() {
    document.querySelector(".fullview__close").remove();
    document.querySelector("canvas").remove();
    this.clearCursor();
  },
  components: {
    BaseView,
    CursorCustom,
    PageHistory
  }
};
</script>

<style lang="sass" scoped>
@import "src/sass/general/variables"
@import "src/sass/general/page"
.base
  background: $dark
</style>
